import { render, staticRenderFns } from "./contractDetailFee.vue?vue&type=template&id=039297f2&scoped=true"
import script from "./contractDetailFee.vue?vue&type=script&lang=js"
export * from "./contractDetailFee.vue?vue&type=script&lang=js"
import style0 from "./contractDetailFee.vue?vue&type=style&index=0&id=039297f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039297f2",
  null
  
)

export default component.exports